/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  // Red de seguridad para el buscador (Boost AI Search & Filter): al hacer
  // click en un resultado del desplegable, Boost cancela la navegación por
  // defecto y la reintenta después de mandar su propio tracking. Detectamos
  // que ese POST a /api/event/collect a veces se aborta (net::ERR_ABORTED),
  // dejando la promesa que dispara el redirect sin resolverse nunca: el
  // click no hace nada. Si a los 900ms seguimos en la misma página,
  // navegamos nosotros mismos. Si Boost ya navegó, esto no hace nada.
  //
  // Se escucha en document (no en #Search) porque el desplegable de Boost
  // no siempre queda anidado dentro del contenedor del buscador. Se usa la
  // fase de captura para leer el click antes de que Boost pueda detener su
  // propagación.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.bc-sf-search-suggestion a[href], .ui-menu-item-wrapper[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (link.target === '_blank') return; // no forzar la pestaña actual si el link abre en una nueva

    var startUrl = window.location.href;
    var targetUrl = link.href;

    setTimeout(function () {
      if (window.location.href === startUrl) {
        window.location.assign(targetUrl);
      }
    }, 900);
  }, true);
})();

(function () {
  // Checkbox "¿Es un regalo?" por producto en el carrito: muestra/oculta el
  // campo de nota de ese producto y guarda ambos valores como atributos del
  // carrito (cart.attributes), con una clave distinta por producto/variante,
  // vía AJAX, igual que la nota de pedido nativa del tema. Así el dato
  // persiste aunque el carrito se vuelva a renderizar desde el servidor (por
  // ejemplo al cambiar una cantidad) y llega al pedido para que lo vea el
  // dueño de la tienda.
  function syncCartAttributes(attributes) {
    fetch(window.theme.localeRootUrl + '/cart/update.js', {
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-gift-checkbox]');

    if (checkbox) {
      var wrapper = checkbox.closest('.CartItem__Gift');
      var container = wrapper.querySelector('[data-gift-note-container]');
      var giftKey = checkbox.getAttribute('data-gift-key');
      var noteKey = checkbox.getAttribute('data-note-key');

      container.style.display = checkbox.checked ? '' : 'none';

      var attributes = {};
      attributes[giftKey] = checkbox.checked ? 'Sí' : '';

      if (!checkbox.checked) {
        var textarea = container.querySelector('[data-gift-note]');
        if (textarea) textarea.value = '';
        attributes[noteKey] = '';
      }

      syncCartAttributes(attributes);
      return;
    }

    var note = event.target.closest('[data-gift-note]');
    if (note) {
      var noteCheckbox = note.closest('.CartItem__Gift').querySelector('[data-gift-checkbox]');
      var attributesForNote = {};
      attributesForNote[noteCheckbox.getAttribute('data-note-key')] = note.value;
      syncCartAttributes(attributesForNote);
    }
  });
})();

(function () {
  // Selector de talla en el carrito: como el carrito de Shopify no permite
  // cambiar la variante de una línea existente, se remueve la línea actual y
  // se agrega la nueva talla con la misma cantidad. Si el producto estaba
  // marcado como regalo, se traslada esa nota a la clave de atributo de la
  // nueva talla (la clave incluye el título de la variante) para que no se
  // pierda. Al terminar se recarga la página para reflejar el nuevo estado
  // del carrito (nuevas claves de línea, disponibilidad, etc.).
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-size-switcher]');
    if (!select) return;

    var cartItem = select.closest('.CartItem');
    var lineKey = select.getAttribute('data-line-key');
    var productTitle = select.getAttribute('data-product-title');
    var newVariantId = select.value;
    var selectedOption = select.options[select.selectedIndex];
    var newVariantTitle = selectedOption.getAttribute('data-variant-title');

    var quantityInput = cartItem.querySelector('.QuantitySelector__CurrentQuantity');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    var giftCheckbox = cartItem.querySelector('[data-gift-checkbox]');
    var wasGift = giftCheckbox ? giftCheckbox.checked : false;
    var oldGiftKey = giftCheckbox ? giftCheckbox.getAttribute('data-gift-key') : null;
    var oldNoteKey = giftCheckbox ? giftCheckbox.getAttribute('data-note-key') : null;
    var giftNoteTextarea = cartItem.querySelector('[data-gift-note]');
    var noteValue = giftNoteTextarea ? giftNoteTextarea.value : '';

    select.disabled = true;

    fetch(window.theme.localeRootUrl + '/cart/change.js', {
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function () {
      return fetch(window.theme.localeRootUrl + '/cart/add.js', {
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: quantity }] }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }).then(function () {
      if (!oldGiftKey || !oldNoteKey) {
        return null;
      }

      var newGiftKey = 'Es un regalo - ' + productTitle + ' (' + newVariantTitle + ')';
      var newNoteKey = 'Nota de regalo - ' + productTitle + ' (' + newVariantTitle + ')';
      var attributes = {};

      attributes[oldGiftKey] = '';
      attributes[oldNoteKey] = '';

      if (wasGift) {
        attributes[newGiftKey] = 'Sí';
        attributes[newNoteKey] = noteValue;
      }

      return fetch(window.theme.localeRootUrl + '/cart/update.js', {
        body: JSON.stringify({ attributes: attributes }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }).then(function () {
      window.location.reload();
    });
  });
})();
(function () {
  // Flechas de la tarjeta de producto (grilla de Boost): cambian la foto visible
  // sin entrar a la ficha. Las fotos posteriores a la primera no traen src en el
  // HTML (data-pp-src) para no descargar todas las fotos de todas las tarjetas:
  // se cargan al navegar a ellas, y se precarga la siguiente.
  function ppLoadSlide(img) {
    if (img && !img.getAttribute('src') && img.getAttribute('data-pp-src')) {
      img.setAttribute('src', img.getAttribute('data-pp-src'));
    }
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.pp-arrow');
    if (!arrow) return;

    // Las flechas viven dentro del link de la tarjeta: hay que evitar que naveguen a la ficha
    event.preventDefault();
    event.stopPropagation();

    var gallery = arrow.closest('.pp-gallery');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('img[data-pp-index]'));
    if (slides.length < 2) return;

    var current = 0;
    slides.forEach(function (img, position) {
      if (img.classList.contains('pp-active')) current = position;
    });

    var direction = parseInt(arrow.getAttribute('data-pp-dir'), 10);
    var next = (current + direction + slides.length) % slides.length;

    ppLoadSlide(slides[next]);
    slides[current].classList.remove('pp-active');
    slides[next].classList.add('pp-active');
    ppLoadSlide(slides[(next + direction + slides.length) % slides.length]);
  }, true);
})();

(function () {
  // Botón "Aplicar filtros": Boost aplica cada filtro apenas se toca, con un pedido
  // por cada click. Acá se difiere ese pedido: mientras se eligen filtros, Boost va
  // actualizando la URL y sus parámetros, pero el pedido de productos recién sale
  // cuando se aprieta "Aplicar filtros". Las acciones explícitas (borrar filtros,
  // ordenar, paginar) siguen aplicándose al instante.
  var IMMEDIATE_EVENTS = /^(init|resend|history|page|display|sort|clear)/;
  var pending = false;
  var pendingEvent = 'filter';
  var applying = false;

  function updateButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('.pp-apply-button'), function (button) {
      button.disabled = !pending;
    });
  }

  function patchBoost() {
    if (!window.BCSfFilter || !BCSfFilter.prototype.getFilterData) return false;
    if (BCSfFilter.prototype.ppPatched) return true;

    var original = BCSfFilter.prototype.getFilterData;
    BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
      if (typeof eventType === 'string' && !applying && !IMMEDIATE_EVENTS.test(eventType)) {
        pending = true;
        pendingEvent = eventType;
        updateButtons();
        return;
      }

      pending = false;
      updateButtons();
      return original.call(this, eventType, errorCount);
    };
    BCSfFilter.prototype.ppPatched = true;
    return true;
  }

  var patchAttempts = 0;
  var patchTimer = setInterval(function () {
    if (patchBoost() || ++patchAttempts > 50) clearInterval(patchTimer);
  }, 200);

  // Como no se vuelve a pedir/renderizar nada hasta aplicar, la marca de "seleccionado" de la pill se cambia acá
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.bc-sf-filter-option-block-list li a.bc-sf-filter-option-label');
    if (!link || !pending) return;

    var block = link.closest('.bc-sf-filter-option-block');
    var displayType = block.getAttribute('data-display-type');
    var type = block.getAttribute('data-type');
    if (type === 'collection' || displayType === 'sub_category') return;

    var item = link.closest('li');
    var selected = !link.classList.contains('selected');

    if (block.getAttribute('data-select-type') === 'single') {
      Array.prototype.forEach.call(block.querySelectorAll('li a, li input'), function (el) {
        el.classList.remove('selected');
      });
    }

    link.classList.toggle('selected', selected);
    var input = item.querySelector('input');
    if (input) input.classList.toggle('selected', selected);
  });

  function ensureApplyButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('#bc-sf-filter-tree, #bc-sf-filter-tree2'), function (tree) {
      var wrapper = tree.querySelector('#bc-sf-filter-options-wrapper');
      if (!wrapper || wrapper.querySelector('.pp-apply-wrap')) return;

      var box = document.createElement('div');
      box.className = 'pp-apply-wrap';
      box.innerHTML = '<button type="button" class="pp-apply-button">Aplicar filtros</button>';
      wrapper.appendChild(box);
      box.firstChild.disabled = !pending;
    });
  }

  // Signo $ también en el resumen de filtros elegidos ("Precio: 175 - 1,679")
  function prefixSelectedPrice() {
    Array.prototype.forEach.call(document.querySelectorAll('.bc-sf-filter-selected-items .selected-item .selected-type'), function (label) {
      var name = label.querySelector('span');
      var value = label.querySelector('strong');
      if (!name || !value || !/^precio/i.test(name.textContent.trim())) return;
      if (value.textContent.indexOf('$') > -1) return;

      value.textContent = value.textContent.replace(/([\d][\d.,]*)/g, '$$$1');
    });
  }

  // Agrega las etiquetas "Desde" / "Hasta" sobre los campos de precio (el
  // HTML de ese bloque lo genera Boost, así que no se puede escribir
  // directo en el Liquid). Envuelve cada input en su propio contenedor para
  // poder separar visualmente label + campo del espacio entre ambos campos.
  function addPriceFieldLabels() {
    Array.prototype.forEach.call(document.querySelectorAll('.bc-sf-filter-option-range-amount'), function (wrap) {
      if (wrap.querySelector('.pp-price-field')) return;

      var min = wrap.querySelector('.bc-sf-filter-option-range-amount-min');
      var max = wrap.querySelector('.bc-sf-filter-option-range-amount-max');
      if (!min || !max) return;

      function wrapField(input, labelText) {
        var field = document.createElement('div');
        field.className = 'pp-price-field';
        var label = document.createElement('span');
        label.className = 'pp-price-label';
        label.textContent = labelText;
        input.parentNode.insertBefore(field, input);
        field.appendChild(label);
        field.appendChild(input);
      }

      wrapField(min, 'Desde');
      wrapField(max, 'Hasta');
    });
  }

  function refresh() {
    ensureApplyButtons();
    prefixSelectedPrice();
    addPriceFieldLabels();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.pp-apply-button');
    if (!button || button.disabled) return;

    applying = true;
    try {
      bcsffilter.getFilterData(pendingEvent);
    } finally {
      applying = false;
    }

    // En el drawer de mobile, aplicar cierra el panel para ver los resultados
    var drawer = button.closest('#collection-filter-drawer');
    if (drawer) {
      var close = drawer.querySelector('[data-action="close-drawer"]');
      if (close) close.click();
    }
  });

  // Lo usan otros controles (ej. "Solo disponibles") para aplicar al instante lo que dejaron elegido
  window.ppApplyFilters = function () {
    if (!pending) return;
    applying = true;
    try {
      bcsffilter.getFilterData(pendingEvent);
    } finally {
      applying = false;
    }
  };

  var observer = new MutationObserver(refresh);
  function observeTrees() {
    var containers = document.querySelectorAll('#bc-sf-filter-tree, #bc-sf-filter-tree2');
    if (!containers.length) return false;
    Array.prototype.forEach.call(containers, function (container) {
      observer.observe(container, { childList: true, subtree: true });
    });
    refresh();
    return true;
  }

  if (!observeTrees()) {
    document.addEventListener('DOMContentLoaded', observeTrees);
  }
})();

(function () {
  // Filtros arriba de la grilla (desktop, desde 1008px, ver pp-collection.css):
  // cada grupo de filtros es una pill que abre un desplegable. Se intercepta el
  // click del título en fase de captura para que no corra el slideUp/slideDown
  // de Boost, que pelearía con el desplegable. En pantallas chicas (drawer) se
  // deja que Boost maneje sus acordeones como siempre.
  var BAR_QUERY = '(min-width: 1008px)';

  function isBarMode() {
    return window.matchMedia(BAR_QUERY).matches;
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('#bc-sf-filter-tree .pp-open'), function (block) {
      if (block !== except) block.classList.remove('pp-open');
    });
  }

  document.addEventListener('click', function (event) {
    if (!isBarMode()) return;

    var title = event.target.closest('#bc-sf-filter-tree .bc-sf-filter-block-title h3');
    if (title) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var block = title.closest('.bc-sf-filter-option-block');
      var willOpen = !block.classList.contains('pp-open');
      closeAll(block);
      block.classList.toggle('pp-open', willOpen);
      return;
    }

    // Click fuera de un desplegable abierto: se cierra
    if (!event.target.closest('#bc-sf-filter-tree .pp-open')) closeAll(null);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  // Marca las pills que tienen algún valor elegido (queda en verde) para poder
  // ver de un vistazo qué filtros hay activos sin abrir cada desplegable.
  function markSelections() {
    Array.prototype.forEach.call(document.querySelectorAll('#bc-sf-filter-tree .bc-sf-filter-option-block'), function (block) {
      var hasListSelection = !!block.querySelector('a.bc-sf-filter-option-label.selected');
      var slider = block.querySelector('.bc-sf-filter-option-range-slider');
      var hasRangeSelection = !!(slider && slider.getAttribute('data-value') && /pf_vp_|pf_p_/.test(window.location.search));
      block.classList.toggle('pp-has-selection', hasListSelection || hasRangeSelection);
    });
  }

  // Cuando se aplica un filtro y Boost redibuja el árbol, se cierran los desplegables
  var markObserver = new MutationObserver(markSelections);
  function init() {
    var tree = document.getElementById('bc-sf-filter-tree');
    if (!tree) return false;
    markObserver.observe(tree, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-value'] });
    markSelections();
    return true;
  }

  if (!init()) document.addEventListener('DOMContentLoaded', init);
})();

(function () {
  // Precios sin decimales también cuando la app de conversión de moneda
  // (Bucks) los muestra en otra moneda ("$65.46 USD", "$99.905,67 ARS"). Esa
  // app no tiene opción para sacarlos, pero arma el texto con una tabla de
  // formatos por moneda (bucksCC.currencyFormats, con marcadores como
  // {{amount}}). Se cambian los marcadores a su variante "sin decimales", así
  // todo lo que convierta de ahí en más sale sin decimales, y se vuelven a
  // escribir los precios que ya hubiera convertido antes de este cambio.
  //
  // IMPORTANTE: no alcanza con reescribir el texto de los precios: la app
  // detecta ese texto como un precio nuevo y lo vuelve a convertir (dejando
  // importes incorrectos). Por eso al reescribir también se actualiza el
  // atributo bucks-current, con el que la app reconoce lo que ella misma
  // escribió. En pesos mexicanos (la moneda de la tienda) no hay conversión
  // ni decimales, así que nada de esto aplica.
  var PLACEHOLDERS = [
    ['{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}'],
    ['{{amount_with_space_separator}}', '{{amount_no_decimals_with_space_separator}}'],
    ['{{amount_with_apostrophe_separator}}', '{{amount_no_decimals_with_apostrophe_separator}}'],
    ['{{amount}}', '{{amount_no_decimals}}']
  ];
  var HAS_DECIMALS = /\d[.,]\d{2}(?!\d)/;
  var formatsPatched = false;

  function patchFormats() {
    var formats = window.bucksCC && window.bucksCC.currencyFormats;
    if (!formats) return false;
    if (formatsPatched) return true;

    Object.keys(formats).forEach(function (code) {
      ['money_format', 'money_with_currency_format'].forEach(function (key) {
        var value = formats[code] && formats[code][key];
        if (typeof value !== 'string') return;
        for (var i = 0; i < PLACEHOLDERS.length; i++) {
          if (value.indexOf(PLACEHOLDERS[i][0]) > -1) {
            formats[code][key] = value.replace(PLACEHOLDERS[i][0], PLACEHOLDERS[i][1]);
            break;
          }
        }
      });
    });

    formatsPatched = true;
    return true;
  }

  // Número de un texto de precio ("$99.905,67 ARS" -> 99905.67)
  function parsePrice(text) {
    var match = text.match(/\d[\d.,]*/);
    if (!match) return NaN;
    var raw = match[0];
    var decimalMatch = raw.match(/[.,](\d{2})$/);
    var integerPart = decimalMatch ? raw.slice(0, -3) : raw;
    return parseFloat(integerPart.replace(/[.,]/g, '') + (decimalMatch ? '.' + decimalMatch[1] : ''));
  }

  function fixConvertedPrices() {
    if (!patchFormats() || typeof window.bucksCC.appConverter !== 'function') return;

    Array.prototype.forEach.call(document.querySelectorAll('.buckscc-converted[bucks-init]'), function (element) {
      var current = element.textContent;
      if (!HAS_DECIMALS.test(current)) return;

      var original = parseFloat(element.getAttribute('bucks-init'));
      if (isNaN(original)) return;

      var next;
      try {
        next = window.bucksCC.appConverter(original);
      } catch (error) {
        return;
      }

      // Seguro: solo se acepta si es el mismo importe redondeado (nunca otro valor)
      var before = parsePrice(current);
      var after = parsePrice(String(next));
      if (typeof next !== 'string' || isNaN(before) || isNaN(after) || Math.abs(before - after) > 1) return;

      element.textContent = next;
      element.setAttribute('bucks-current', next);
    });
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      fixConvertedPrices();
    }, 50);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  // La app carga y convierte de forma asíncrona: se reintenta unos segundos
  var attempts = 0;
  var poll = setInterval(function () {
    fixConvertedPrices();
    if (++attempts > 60) clearInterval(poll);
  }, 250);
})();

(function () {
  // ---------------------------------------------------------------------------
  // Barra inferior de la colección: contador de productos y "Solo disponibles"
  // ---------------------------------------------------------------------------
  var STOCK_SELECTOR = 'input[data-id="pf_st_disponibilidad"][data-value="true"]';
  var lastCount = null;

  function getBar() {
    return document.querySelector('.CollectionToolbar--bottom .CollectionToolbar__Group');
  }

  function isStockSelected() {
    var boostInput = document.querySelector('#bc-sf-filter-tree ' + STOCK_SELECTOR);
    if (!boostInput) return false;
    var link = boostInput.parentNode.querySelector('a.bc-sf-filter-option-label');
    return boostInput.checked || boostInput.classList.contains('selected') || !!(link && link.classList.contains('selected'));
  }

  function ensureMeta() {
    var group = getBar();
    if (!group) return null;

    var meta = group.querySelector('.pp-bar-meta');
    if (meta) return meta;

    meta = document.createElement('div');
    meta.className = 'pp-bar-meta';
    meta.innerHTML =
      '<span class="pp-bar-meta__count" aria-live="polite"></span>' +
      '<label class="pp-bar-meta__toggle"><input type="checkbox" class="pp-only-available"> Solo disponibles</label>';
    group.insertBefore(meta, group.firstChild);

    meta.querySelector('input').addEventListener('change', function () {
      var boostInput = document.querySelector('#bc-sf-filter-tree ' + STOCK_SELECTOR);
      if (!boostInput) {
        this.checked = !this.checked;
        return;
      }
      // El estado actual del filtro de Boost manda: si ya coincide no se vuelve a tocar
      if (isStockSelected() !== this.checked) boostInput.click();
      if (window.ppApplyFilters) window.ppApplyFilters();
    });

    return meta;
  }

  function renderCount() {
    var meta = ensureMeta();
    if (!meta) return;

    var count = meta.querySelector('.pp-bar-meta__count');
    if (lastCount === null) {
      count.textContent = '';
    } else {
      count.textContent = lastCount + (lastCount === 1 ? ' producto' : ' productos');
    }

    meta.querySelector('input').checked = isStockSelected();
    // Si la colección no tiene el filtro de disponibilidad, el control no tiene sentido
    var hasFilter = !!document.querySelector('#bc-sf-filter-tree ' + STOCK_SELECTOR);
    meta.querySelector('.pp-bar-meta__toggle').style.display = hasFilter ? '' : 'none';
  }

  // Lo llama Boost cada vez que llegan resultados (ver buildAdditionalElements)
  window.ppSetCount = function (total) {
    lastCount = total;
    renderCount();
    setTimeout(renderCount, 150);
  };

  // ---------------------------------------------------------------------------
  // Altura de la barra -> variable CSS + botón de WhatsApp siempre por encima
  // ---------------------------------------------------------------------------
  function syncOffsets() {
    var bar = document.querySelector('.CollectionToolbar--bottom');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--pp-toolbar-h', height + 'px');

    var widget = document.querySelector('[id^="gb-widget"]');
    if (!widget) return;

    // El widget fija su "bottom" inline con !important: solo se puede pisar de la misma forma
    var wanted = (bar ? height + 16 : 14) + 'px';
    if (widget.style.getPropertyValue('bottom') !== wanted || widget.style.getPropertyPriority('bottom') !== 'important') {
      widget.style.setProperty('bottom', wanted, 'important');
    }
  }

  var offsetTimer = null;
  function scheduleOffsets() {
    clearTimeout(offsetTimer);
    offsetTimer = setTimeout(syncOffsets, 30);
  }

  // ---------------------------------------------------------------------------
  // Selector de moneda (Bucks) en el footer en lugar de flotar sobre la página
  // ---------------------------------------------------------------------------
  function moveCurrency() {
    var slot = document.querySelector('.pp-currency-slot');
    var box = document.querySelector('.buckscc-floating-box');
    if (!slot || !box || slot.contains(box)) return;
    slot.appendChild(box);
  }

  // ---------------------------------------------------------------------------
  // Swatch (imagen del producto con ese color) junto a cada color del filtro
  // ---------------------------------------------------------------------------
  var swatchMap = null;
  var swatchRequested = false;
  var IMAGE_BASE = '/cdn/shop/files/';

  function loadSwatches(callback) {
    if (swatchMap) return callback();
    if (swatchRequested || !window.ppSwatchUrl) return;
    swatchRequested = true;

    fetch(window.ppSwatchUrl).then(function (response) { return response.json(); }).then(function (map) {
      swatchMap = map;
      callback();
    }).catch(function () {});
  }

  function sizedImage(file, width) {
    return IMAGE_BASE + file.replace(/(\.[a-z0-9]+)$/i, '_' + width + 'x$1');
  }

  function paintFilterSwatches() {
    var blocks = document.querySelectorAll('.bc-sf-filter-option-block-color');
    if (!blocks.length) return;

    loadSwatches(function () {
      Array.prototype.forEach.call(blocks, function (block) {
        Array.prototype.forEach.call(block.querySelectorAll('a.bc-sf-filter-option-label'), function (link) {
          if (link.querySelector('.pp-filter-swatch')) return;

          var name = (link.getAttribute('data-title') || '').toLowerCase();
          var file = swatchMap[name];
          var dot = document.createElement('span');
          dot.className = 'pp-filter-swatch';
          dot.setAttribute('aria-hidden', 'true');
          if (file) dot.style.backgroundImage = 'url(' + sizedImage(file, 120) + ')';
          link.insertBefore(dot, link.firstChild);
        });
      });
    });
  }

  // ---------------------------------------------------------------------------
  var treeObserver = new MutationObserver(function () {
    paintFilterSwatches();
    renderCount();
  });

  function init() {
    ensureMeta();
    moveCurrency();
    syncOffsets();
    paintFilterSwatches();

    ['#bc-sf-filter-tree', '#bc-sf-filter-tree2'].forEach(function (selector) {
      var node = document.querySelector(selector);
      if (node && !node.__ppSwatchObserved) {
        node.__ppSwatchObserved = true;
        treeObserver.observe(node, { childList: true, subtree: true });
      }
    });
  }

  // Bucks y el widget de WhatsApp se insertan tarde: se vigila el body mientras aparecen
  var bodyObserver = new MutationObserver(function () {
    moveCurrency();
    scheduleOffsets();
  });

  function start() {
    init();
    bodyObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', scheduleOffsets);
    if (window.ResizeObserver) {
      var bar = document.querySelector('.CollectionToolbar--bottom');
      if (bar) new ResizeObserver(scheduleOffsets).observe(bar);
    }

    var attempts = 0;
    var poll = setInterval(function () {
      init();
      if (++attempts > 40) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function () {
  // Swatches de color de la tarjeta: la foto de la tarjeta pasa a la de la variante elegida
  function fileKey(url) {
    if (!url) return '';
    var name = url.split('?')[0].split('/').pop();
    return name.replace(/_(\{width\}|\d+)x(\d+)?(?=\.)/, '').replace(/\.[a-z0-9]+$/i, '').toLowerCase();
  }

  function sizedUrl(url, width) {
    var clean = url.split('?')[0];
    return clean.replace(/(\.[a-z0-9]+)$/i, '_' + width + 'x$1');
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.pp-card-swatch');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('.ProductItem');
    if (!card) return;

    var wanted = fileKey(swatch.getAttribute('data-pp-image'));
    var wrapper = card.querySelector('.AspectRatio');
    if (!wrapper || !wanted) return;

    var slides = Array.prototype.slice.call(wrapper.querySelectorAll('img[data-pp-index]'));
    var target = null;

    slides.forEach(function (img) {
      var source = img.getAttribute('data-src') || img.getAttribute('data-pp-src') || img.getAttribute('src');
      if (!target && fileKey(source) === wanted) target = img;
    });

    // Si la foto no está entre las de la galería de la tarjeta, se agrega
    if (!target) {
      target = document.createElement('img');
      target.className = 'ProductItem__Image pp-slide';
      target.setAttribute('data-pp-index', String(slides.length));
      target.setAttribute('data-pp-src', sizedUrl(swatch.getAttribute('data-pp-image'), 800));
      target.alt = '';
      var anchor = wrapper.querySelector('.pp-arrow, .Image__Loader');
      wrapper.insertBefore(target, anchor);
      slides.push(target);
    }

    if (!target.getAttribute('src') && target.getAttribute('data-pp-src')) {
      target.setAttribute('src', target.getAttribute('data-pp-src'));
    }

    wrapper.classList.add('pp-gallery');
    slides.forEach(function (img) { img.classList.toggle('pp-active', img === target); });

    Array.prototype.forEach.call(card.querySelectorAll('.pp-card-swatch'), function (button) {
      button.classList.toggle('is-active', button === swatch);
    });
  }, true);
})();

(function () {
  // El tema reescribe el precio al cambiar de variante: se vuelve a poner la etiqueta de descuento
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var list = document.querySelector('.ProductMeta__PriceList');
    if (!list) return;

    var old = list.querySelector('.ProductMeta__Discount');
    if (old) old.parentNode.removeChild(old);

    if (!variant || !(variant.compare_at_price > variant.price)) return;
    var percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
    if (percent <= 0) return;

    var pill = document.createElement('span');
    pill.className = 'ProductMeta__Discount';
    pill.textContent = '-' + percent + '%';
    list.appendChild(pill);
  });
})();

(function () {
  // Mesa de regalos: agrega el producto a la lista guardada en este navegador (se comparte desde la página de la mesa)
  var KEY = 'pp_gift_list';

  function load() {
    try {
      var data = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (data && Array.isArray(data.items)) return data;
    } catch (e) {}
    return { name: '', items: [] };
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); return true; } catch (e) { return false; }
  }

  function sync(button) {
    var handle = button.getAttribute('data-handle');
    var inList = load().items.some(function (i) { return i.h === handle; });
    var label = button.querySelector('[data-pp-gift-label]');
    if (label) label.textContent = inList ? 'En tu mesa de regalos' : 'Agregar a mi mesa de regalos';
    button.classList.toggle('is-added', inList);
    var note = button.parentNode.querySelector('[data-pp-gift-note]');
    if (note) note.hidden = !inList;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pp-gift]');
    if (!button) return;

    var handle = button.getAttribute('data-handle');
    var list = load();
    var exists = list.items.some(function (i) { return i.h === handle; });
    if (!exists) {
      list.items.push({ h: handle, q: 1 });
      if (!save(list)) {
        window.alert('No pudimos guardar tu lista en este navegador. Prueba abrir la tienda en una ventana normal (no privada).');
        return;
      }
    }
    sync(button);
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-pp-gift]'), sync);
})();
